// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../fichesalarie/listerubriques/listerubriquessalarie.ts" />
import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { JourFerieDto } from "../../../dto/GenApi.iNotPaie.Dto/JourFerieDto";
import { ParametresInstance } from "../../Controls/Parameters";
import moment from "moment";
import { TypeJournee } from "../../../dto/GenApi.iNotPaie.Dto/TypeJournee";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

interface TypeJourneeInfo {
	type: TypeJournee;
	libelle: string;
}

@Component
export default class ModalAjoutUpdateJourFerie extends Vue {
	public isUpdate = false;
	public jourFerie: JourFerieDto = {
    	Id: 0,
    	Date: new Date(),
    	EstPaye: false,
    	Libelle: "",
    	IdSociete: 0,
    	TypeJournee: TypeJournee.JourneeEntiere
	};

	public date = "";

	public typeJournee: TypeJourneeInfo[] = [{ libelle: "Journée entière", type: TypeJournee.JourneeEntiere },
    	{ libelle: "Matin", type: TypeJournee.Matin },
    	{ libelle: "Après-midi", type: TypeJournee.ApresMidi }]

	public Init(id?: any): void {
    	this.isUpdate = id != undefined;
    	if (ParametresInstance.societeCourante == undefined || ParametresInstance.societeCourante.Code == undefined) {
    		return;
    	}
    	const idSociete = ParametresInstance.societeCourante.Id;

    	if (this.isUpdate) {
    		ServicesFactoryInstance.JoursFeriesService.getJourFerieById(id, (data) => {
    			this.jourFerie = data;
    			this.date = moment.utc(this.jourFerie.Date).format("YYYY-MM-DD");
    		});
    	} else {
    		this.jourFerie = {
    			Id: 0,
    			Date: new Date(),
    			EstPaye: false,
    			Libelle: "",
    			IdSociete: idSociete,
    			TypeJournee: TypeJournee.JourneeEntiere
    		};
    		this.date = "";
    	}
    	this.$forceUpdate();
	}

	public annuler(): void {
    	$("#modalAjoutUpdateJourFerie").modal("hide");
	}

	public ajouter(): void {
    	this.jourFerie.Date = moment.utc(this.date).toDate();
    	ServicesFactoryInstance.JoursFeriesService.addJourFerie(this.jourFerie, () => {
    		this.annuler();
    		NotificationServiceInstance.SendSuccess("Le jour férié a été ajouté avec succès.");
    		this.$emit("refresh");
    	});
	}

	public update(): void {
    	this.jourFerie.Date = moment.utc(this.date).toDate();
    	ServicesFactoryInstance.JoursFeriesService.updateJourFerie(this.jourFerie, () => {
    		this.annuler();
    		NotificationServiceInstance.SendSuccess("Le jour férié a été modifié avec succès.");
    		this.$emit("refresh");
    	});
	}
}



// WEBPACK FOOTER //
// ./src/components/joursFeries/modalAjoutUpdateJourFerie/modalAjoutUpdateJourFerie.ts